var map = {
	"./Alert.svg": "4b6a",
	"./Checkbox-active.svg": "0b47",
	"./Checkbox-inactive.svg": "46f3",
	"./Close.svg": "753b",
	"./Copy.svg": "f3bd",
	"./ETH.svg": "fd1a",
	"./Info.svg": "1b65",
	"./InfoOutline.svg": "4d32",
	"./RMB.svg": "ffd3",
	"./Scan.svg": "e6f5",
	"./Stopwatch.svg": "32b9",
	"./Success.svg": "6935",
	"./USDC.svg": "74d2",
	"./USDT.svg": "d304",
	"./VND.svg": "b1b9",
	"./WalletError.svg": "4ec6",
	"./fail.svg": "4c44",
	"./submit-success.svg": "bd62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";